import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit/typography';
import { InlineButton } from '../InlineButton';

export interface IChangePhoneProps {
  phone: string;

  onChangeClick(): void;
}

export const ChangePhone: React.FC<IChangePhoneProps> = ({ phone, onChangeClick }) => {
  return (
    <div>
      <InlineText1>Введите код, который мы отправили на номер {phone} </InlineText1>
      <InlineButton onClick={onChangeClick}>Изменить номер</InlineButton>
    </div>
  );
};

ChangePhone.displayName = 'ChangePhone';
